import Localization from '~/client/src/shared/localization/LocalizationManager'

import { ResourceTypeId } from './resourceTypes'

interface ResourceTypeLabels {
  createTitle: () => string
  sectionLabel: () => string
  formLabel: () => string
  creationFormLabel: () => string
}

const FALLBACK: ResourceTypeLabels = {
  createTitle: () => Localization.translator.create,
  sectionLabel: () => Localization.translator.details,
  formLabel: () => Localization.translator.formProperties,
  creationFormLabel: () => Localization.translator.form,
}

const LABELS: Partial<Record<string, ResourceTypeLabels>> = {
  [ResourceTypeId.OFFLOADING_EQUIPMENT]: {
    createTitle: () => Localization.translator.createNewEquipment,
    sectionLabel: () => Localization.translator.equipmentPropertiesLabel,
    formLabel: () => Localization.translator.equipmentForm,
    creationFormLabel: () => Localization.translator.equipmentCreationForm,
  },
  [ResourceTypeId.MATERIALS]: {
    createTitle: () => Localization.translator.createNewMaterial,
    sectionLabel: () => Localization.translator.materialPropertiesLabel,
    formLabel: () => Localization.translator.materialForm,
    creationFormLabel: () => Localization.translator.materialCreationForm,
  },
  [ResourceTypeId.LOCATIONS]: {
    ...FALLBACK,
    createTitle: () => Localization.translator.createNewLocation,
  },
  [ResourceTypeId.SENSORS]: {
    ...FALLBACK,
    createTitle: () => Localization.translator.createNewStruxTag,
  },
}

export const getResourceTypeLabels = (
  resourceTypeId: string,
): ResourceTypeLabels => LABELS[resourceTypeId] ?? FALLBACK

// A lookup rather than a ternary: a fourth resource type reading "Select Equipment Form"
// is the kind of wrong-but-plausible string nobody reports.
export const getSelectFormTitle = (resourceTypeId?: string): string => {
  switch (resourceTypeId) {
    case ResourceTypeId.MATERIALS:
      return Localization.translator.selectMaterialForm
    case ResourceTypeId.LOCATIONS:
      return Localization.translator.selectLocationForm
    default:
      return Localization.translator.selectEquipmentForm
  }
}
